<template class="lefts">

  <div class="home" >
    <br/>
    <div class="container">

      <template>
        <v-container grid-list-md text-xs-center>
          <v-layout row wrap>
            <v-flex xs12>
              <div class="topDiv">
                <v-layout row wrap>
                  <v-flex xl3 lg4 md5 sm12>
                    <div class="calendarioMenu">
                      <v-date-picker
                              v-model="date"
                              class="datePicker"
                              color="var(--color-calendar)"
                              :events="functionEvents"
                              first-day-of-week=1
                              locale='es'
                      ></v-date-picker>
                    </div>
                  </v-flex>



                  <v-flex xl9 lg8 md7 sm12 class="tablaSuperior">
                    <v-flex xs12 class="toolbarSuperior">
                      <v-card :loading="loading">
                        <v-toolbar
                                class="toolbars"
                                dark
                        >
                          <v-toolbar-title>Avisos y Eventos {{ date }}</v-toolbar-title>

                          <v-spacer></v-spacer>

                        </v-toolbar>

                        <v-list three-line
                                style="max-height: 300px"
                                class="overflow-y-auto"
                        >
                            <v-card v-if="avisosEventos.length===0" flat>
                                <center>
                                <v-card-subtitle>
                                    No existen avisos o eventos para el día seleccionado
                                </v-card-subtitle>
                                </center>
                            </v-card>
                          <template v-for="(item, index) in avisosEventos">
                            <v-subheader
                                    v-if="item.header"
                                    :key="item.header"
                                    v-text="item.header"
                            ></v-subheader>

                            <v-divider
                                    v-else-if="item.divider"
                                    :key="index"
                                    :inset="item.inset"
                            ></v-divider>

                            <v-list-item
                                    v-else
                                    :key="item.title"
                            >
                              <v-list-item-avatar>
                                <i v-if="item.eventDate != undefined" class="fa fa-calendar-check"></i>
                                <i v-else class="fa fa-newspaper"></i>
                              </v-list-item-avatar>

                              <v-list-item-content>
                                <v-list-item-title v-html="item.asunto"></v-list-item-title>
                                <v-list-item-subtitle v-html="item.cuerpo"></v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-list>
                      </v-card>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
            <DialogBox ref="resultDialog"></DialogBox>
            <DialogBox ref="confirmationDialog"></DialogBox>

            <v-flex xs12>
              <template>
                <v-row justify="center">
                  <v-dialog v-model="dialog" width="500px">
                    <v-card>
                      <v-card-title>
                        <v-list-item-avatar>
                          <v-img :src="selectedElement.avatar"></v-img>
                        </v-list-item-avatar>
                        <span class="headline">{{ selectedElement.name }}</span>
                        <v-list-item-icon>
                          <i v-if="selectedElement.positivo" class="fas fa-smile colorPos"></i>
                          <i v-else class="fas fa-frown colorNeg"></i>
                        </v-list-item-icon>
                      </v-card-title>
                      <hr>
                      <v-card-title>
                        <span class="headline">{{ selectedElement.asunto }}</span>
                      </v-card-title>
                      <v-card-text>{{ selectedElement.cuerpo }}</v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="deleteItemConfirmation()">Eliminar</v-btn>
                        <v-btn color="blue darken-1" text @click="dialog = false">Cerrar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-row>
              </template>
              <v-card :loading="loadingSugerencias">
                <v-toolbar
                        class="toolbars"
                        dark
                >
                  <v-toolbar-title>Sugerencias no leídas</v-toolbar-title>

                  <v-spacer></v-spacer>

                </v-toolbar>

                <v-card v-if="sugerencias.length===0" flat>
                    <center>
                    <v-card-subtitle>
                        Todas las sugerencias han sido leídas
                    </v-card-subtitle>
                    </center>
                </v-card>

                <v-list three-line>
                  <template v-for="(item, index) in sugerencias">
                    <v-subheader
                            v-if="item.header"
                            :key="item.header"
                            v-text="item.header"
                    ></v-subheader>

                    <v-divider
                            v-else-if="item.divider"
                            :key="index"
                            :inset="item.inset"
                    ></v-divider>

                    <v-list-item
                            v-else
                            :key="item.title"
                            @click="openSugerencia(item)"
                    >
                      <v-list-item-avatar>
                        <v-img :src="item.avatar"></v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title v-html="item.name"></v-list-item-title>
                        <v-list-item-subtitle v-html="item.asunto"></v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-content>
                        <v-list-item-subtitle v-html="item.formattedDate"></v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-icon>
                        <i v-if="item.leido" class="far fa-comment-alt"></i>
                        <i v-else class="fas fa-comment-alt"></i>
                      </v-list-item-icon>
                      <v-list-item-icon>
                        <i v-if="item.positivo" class="fas fa-smile colorPos"></i>
                        <i v-else class="fas fa-frown colorNeg"></i>
                      </v-list-item-icon>
                    </v-list-item>
                  </template>
                </v-list>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </template>
    </div>

  </div>
</template>

<script>
/* eslint-disable no-console */
import DialogBox from '../components/DialogBox';
import { DB } from '../firebase/db';
var moment = require('moment');
moment.locale('es')


export default {
  name: 'home',

  data: () => ({
      loading : '#9FEDD7',
      loadingSugerencias: '#9FEDD7',
      sugerencias: [],
      avisos: [],
      eventos: [],
      avisosEventos: [],
      dialog: false,
      selectedElement : {},
      selectedElementIndex: -1,
      date: undefined,
    }),

    components: {
      DialogBox
    },

    created() {
      this.$emit('updateTitle', 'Inicio');
      this.initialize();
      window.bus.$emit('menu/activarMenu');
    }, 

    watch: {
      date : function(date) {
        this.avisosEventos.splice(0);
        for (let index = 0; index < this.avisos.length; index++) {
          if(moment(this.avisos[index].date).isSame(moment(date), 'day')) {
            this.avisosEventos.push(this.avisos[index]);
          }
        }
        for (let index = 0; index < this.eventos.length; index++) {
          if(moment(this.eventos[index].eventDate).isSame(moment(date), 'day')) {
            this.avisosEventos.push(this.eventos[index]);
          }
        }
      }
    },

    methods: {
      initialize () {
        
        let sugerenciasPromise = new Promise((resolve, reject) => {
            DB.collection('sugerencias').onSnapshot( snapshot => {
              snapshot.docChanges().forEach( change => {
              
                var element = {
                  date : change.doc.data().date,
                  formattedDate : moment.duration(moment(change.doc.data().date).valueOf() - moment().valueOf(), 'milliseconds').humanize(true),
                  asunto : change.doc.data().asunto,
                  avatar : change.doc.data().avatar,
                  cuerpo : change.doc.data().cuerpo,
                  leido : change.doc.data().leido,
                  positivo : change.doc.data().positivo,
                  name : change.doc.data().name,
                  id : change.doc.id
                };

                switch (change.type) {
                  case "added":

                    if(!element.leido){
                      this.sugerencias.push(element);
                    }
                    break;

                  case "modified":
                    var index = -1;
                    for (let i = 0; i < this.sugerencias.length; i++) {
                      if(this.sugerencias[i].id == change.doc.id)
                      {
                        index = i;
                        break;
                      }
                    }
                    if(index != -1){
                      this.sugerencias[index].leido = element.leido;
                    }
                    break;

                  case "removed":
                    index = -1;
                    for (let i = 0; i < this.sugerencias.length; i++) {
                      if(this.sugerencias[i].id == change.doc.id)
                      {
                        index = i;
                        break;
                      }
                    }
                    if(index != -1){
                      this.sugerencias.splice(index, 1);
                    }
                    break;
                }
              });

              this.sugerencias.sort((a, b) => {
                return moment(b.date).valueOf() - moment(a.date).valueOf();
              });

              resolve(snapshot);

            }, error => {
              reject(error);
            });
          })

        let avisosPromise = new Promise((resolve, reject) => {
            DB.collection('avisos').onSnapshot( snapshot => {
              snapshot.docs.forEach( item => {
                let element = {
                  date : item.data().date,
                  endDate : item.data().endDate,
                  formattedDate : moment(item.data().date).format("DD-MM-YYYY"),
                  formattedEndDate : moment(item.data().endDate).format("DD-MM-YYYY"),
                  asunto : item.data().asunto,
                  cuerpo : item.data().cuerpo,
                  id : item.id
                };

                let index = -1;
                for (let i = 0; i < this.avisos.length; i++) {
                  if(this.avisos[i].id == item.id)
                  {
                    index = i;
                    break;
                  }
                }

                if(index == -1){
                  this.avisos.push(element);
                }
                else {
                  this.avisos[index].id = element.id;
                  this.avisos[index].date = element.date;
                  this.avisos[index].endDate = element.endDate;
                  this.avisos[index].formattedDate = moment(element.date).format("DD-MM-YYYY");
                  this.avisos[index].formattedEndDate = moment(element.endDate).format("DD-MM-YYYY");
                  this.avisos[index].asunto = element.asunto;
                  this.avisos[index].cuerpo = element.cuerpo;
                }

                resolve(snapshot);

              }, error => {
                reject(error);
              })
            });
          })

        let eventosPromise = new Promise((resolve, reject) => {
            DB.collection('eventos').onSnapshot( snapshot => {
              snapshot.docs.forEach( item => {
                let element = {
                  date : item.data().date,
                  eventDate : item.data().eventDate,
                  formattedDate : moment(item.data().eventDate).format("DD-MM-YYYY"),
                  asunto : item.data().asunto,
                  cuerpo : item.data().cuerpo,
                  id : item.id
                };

                let index = -1;
                for (let i = 0; i < this.eventos.length; i++) {
                  if(this.eventos[i].id == item.id)
                  {
                    index = i;
                    break;
                  }
                }

                if(index == -1){
                  this.eventos.push(element);
                }
                else {
                  this.eventos[index].id = element.id;
                  this.eventos[index].date = element.date;
                  this.eventos[index].eventDate = element.eventDate;
                  this.eventos[index].formattedDate = moment(element.eventDate).format("DD-MM-YYYY");
                  this.eventos[index].asunto = element.asunto;
                  this.eventos[index].cuerpo = element.cuerpo;
                }

                resolve(snapshot);
              }, error => {
                reject(error);
              })
            })
        })
        
        Promise.all([sugerenciasPromise])
        .then(() => {
            this.loadingSugerencias = false;
        })

        Promise.all([avisosPromise, eventosPromise])
        .then( () => {
            this.date = moment().format("YYYY-MM-DD");
            this.loading = false;
        });
      },

      openSugerencia(element) {
        
        this.selectedElement = element;
        this.selectedElementIndex = this.sugerencias.indexOf(element)
        this.dialog = true

        if(!element.leido) {
          DB.collection('sugerencias').doc(element.id).update({leido: true}).catch(error => {
            console.error(error);
            this.errorDialog("Se ha producido un error al modificar un elemento en la base de datos.");
          })
        }
      },

      deleteItemConfirmation() {
        this.$refs.confirmationDialog.show('warning', 
          `¿Está seguro que quiere eliminar esta sugerencia de ${this.selectedElement.name}?`,
           true,
           this.deleteSugerencia);
      },

      deleteItemSuccess() {
        this.$refs.resultDialog.show('info', "Sugerencia eliminada con éxito.", false);
      },

      errorDialog(error) {
        this.$refs.resultDialog.show('error', error + " Compruebe la conexión a Internet. Si el problema persiste contacte con el administrador.", false);
      },

      deleteSugerencia() {
        return new Promise((resolve, reject) => {
          DB.collection('sugerencias').doc(this.selectedElement.id).delete()
          .then( () => {
            this.deleteItemSuccess();
            this.dialog = false;
            resolve();
          })
          .catch(error => {
            console.error(error);
            this.errorDialog("Se ha producido un error al eliminar el elemento en la base de datos.");
            reject(error)
          })
        })
      },

      functionEvents(date) {
        let calendarEvents = []; 
        for (let index = 0; index < this.avisos.length; index++) {
          if(moment(this.avisos[index].date).isSame(moment(date), 'day')){
            calendarEvents.push('red');
            break;
          }
        }
        for (let index = 0; index < this.eventos.length; index++) {
          if(moment(this.eventos[index].eventDate).isSame(moment(date), 'day')){
            calendarEvents.push('blue');
            break;
          }
        }
        return calendarEvents;
      }
    },
}

</script>


<style>

    .home {
        height: 100%;
    }
  .example-slide {
    align-items: center;
    background-color: var(--color-grey);
    color: var(--color-dark);
    display: flex;
    font-size: 1.5rem;
    justify-content: center;
    height: 30em;
  }
    .image-ajuste {
        max-width:60%;
        margin-left: 25%;
        margin-right: 25%;
        height:auto;
    }

  .calendarioMenu {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .tablaSuperior{
    max-height: 30%;
  }

  .toolbarSuperior{
    max-height: 100%;
  }

  .topDiv {
    max-height: 40%;
  }
</style>